import * as React from "react";
import EverythingProvider, {
  EverythingContext,
} from "./../components/EverythingContext";
import { filterBy } from "./../modules/filterBy";
import Layout from "./../components/Layout";
import DateList from "./../components/DateList";

const IndexPage = () => {
  const [currentObjects, setCurrentObjects] = React.useState([]);
  const [isPristine, setIsPristine] = React.useState(true);

  return (
    <EverythingProvider>
      <EverythingContext.Consumer>
        {(allTheObjects) => {
          // console.log(allTheObjects, currentObjects);
          return (
            <Layout
              filterBy={(type, x) => {
                setIsPristine(false);
                filterBy(type, x, allTheObjects, setCurrentObjects);
              }}
            >
              <DateList
                data={
                  currentObjects.length || !isPristine
                    ? currentObjects
                    : allTheObjects
                }
                key={currentObjects.length}
              />
            </Layout>
          );
        }}
      </EverythingContext.Consumer>
    </EverythingProvider>
  );
};

export default IndexPage;
